import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TRAINING_NAME } from '../../common/constants.js';
import btn_exit from '../../components/atoms/data/btn_exit.svg';

const FooterTraining = (props) => {

    let leftCtrl = (
        <PrevInfo onClick={props.onClickPrev}>
            <PrevButton>
                <i className="fas fa-chevron-left"></i>
            </PrevButton>
            <PrevName>
                {TRAINING_NAME[props.current + 1]}
                <br />
                に戻る
            </PrevName>
        </PrevInfo>
    );
    let rightCtrl = (
        <NextInfo onClick={props.onClickNext}>
            <NextName>
                {TRAINING_NAME[props.current + 3]}
                <br />
                に進む
            </NextName>
            <NextButton>
                <i className="fas fa-chevron-right"></i>
            </NextButton>    
        </NextInfo> 
        );

    if(props.current === 0) {
        leftCtrl = (
            <PrevInfo onClick={props.onClickBack}>
                <PrevButton>
                    <i className="fas fa-chevron-left"></i>
                </PrevButton>
                <PrevName>
                    {TRAINING_NAME[props.current + 1]}
                    <br />
                    に戻る
                </PrevName>
            </PrevInfo>
        );
    } else if(props.current === 3) {
        // 3:シャドーイング画面
        rightCtrl = (
            <NextInfo onClick={props.onClickNext}>
                <NextName>
                    日本語訳
                    <br />
                    を確認する
                </NextName>
                <NextButton>
                    <i className="fas fa-chevron-right"></i>
                </NextButton>    
            </NextInfo> 
        );
    } else if((props.current + 1) === props.maxPage) {
        // 4:日本語訳の確認画面
        rightCtrl = (
        <NextInfo onClick={props.onClickNext}>
            <NextName>
                トレーニングを<br />終了する
            </NextName>
            <FinishButton>
                <i className="fas fa-check"></i>
            </FinishButton>    
        </NextInfo> 
        );
    }

    return(
        <Body>
            <FooterInfo>
                {leftCtrl}
                {rightCtrl}
            </FooterInfo>
        </Body>
    );
}

export { FooterTraining };

FooterTraining.propTypes = {
    current: PropTypes.number.isRequired,
    maxPage: PropTypes.number.isRequired,
    onClickPrev: PropTypes.func.isRequired,
    onClickNext: PropTypes.func.isRequired,
    onClickBack: PropTypes.func.isRequired,
};

const Body = styled.div`
    width: 100%;
    height: 50px;
    background-color: #F2F2F2;
    justify-content: space-between;
    align-items: center;

`;

const FooterInfo = styled.div`
    display: flex;
    font-size: 24px;
    align-items: flex-end;
    // position: absolute;
    // bottom: 0px;
    // left: 0;
    // width: 100%;
`;
const PrevInfo = styled.div`
    margin-right: 1px;
    display: flex;
    width: 50%;
    background: #c5e0b4;
    height: 50px;
`;

const NextInfo = styled.div`
    margin-left: 1px;
    display: flex;
    width: 50%;
    background: #c5e0b4;
    height: 50px;
`;

const PrevName = styled.div`
    justify-content:center;
    margin: auto;
    display: flex;
    width: 100%;
    font-size: 14px;
    text-align: center;
    background: #c5e0b4;
    align-items: center;
`;

const NextName = styled.div`
    justify-content:center;
    display: flex;
    width: 100%;
    font-size: 14px;
    text-align: center;
    background: #c5e0b4;
    align-items: center;
`;

const PrevButton = styled.div`
    margin: auto 0px auto 5px;
    color: #00b050;
    font-size: 32px;
`;
const NextButton = styled.div`
    margin: auto 5px auto 0px;
    color: #00b050;
    font-size: 32px;
`;

const FinishButton = styled.div`
    margin: auto 5px auto 0px;
    color: #00b050;
    font-size: 32px;
`;
